var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 26V10C30 6.68 27.32 4 24 4C20.68 4 18 6.68 18 10V26C15.58 27.82 14 30.74 14 34C14 39.52 18.48 44 24 44C29.52 44 34 39.52 34 34C34 30.74 32.42 27.82 30 26ZM22 10C22 8.9 22.9 8 24 8C25.1 8 26 8.9 26 10H24V12H26V16H24V18H26V22H22V10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureIcon);
export default __webpack_public_path__ + "static/media/temperatureIcon.ccefe4ca42a1c3ccb15d426f3e34d548.svg";
export { ForwardRef as ReactComponent };